<template>
  <div class="collection-details">
    <!-- 标题 -->
    <div class="title_box">
      <div class="title_flex">
        <h4>{{$route.query.name}}</h4>
      </div>
      <div class="inputBox">
        <el-input
          :clearable="true"
          placeholder="请输入专家名称"
          v-model="input"
          clearable
          @change="change"
          :maxlength="330"
        >
        </el-input>
        <el-button
          size="medium"
          style="background: #484c7f; color: #fff"
          @click="searchExpert"
        >搜索</el-button>
      </div>
    </div>
    <div class="foreinger">
      <ul class="foreinger-list">
        <li
          class="foreinger-list-item"
          v-for="(item,index) in aprenderObject.list"
          :key="item.id"
        >

          <!-- //1 -->
          <div class="foreinger-list-item-heda">
            <img :src="item.photo">
          </div>
          <!-- //1 -->
          <!-- //2 -->
          <div class="foreinger-list-item-box">
            <!-- //3 -->
            <div class="foreinger-list-item-title">
              <div class="foreinger-list-item-name">
                {{item.name}}
              </div>
              <div class="foreinger-list-item-country">
                <span class="foreinger-list-item-country1">
                  国家：</span>
                <span class="foreinger-list-item-country2">
                  {{item.country}}
                </span>
              </div>
            </div>
            <!-- //3 -->
            <!-- //4 -->
            <div class="foreinger-list-item-contents">
              <!-- //5 -->
              <div class="foreinger-list-item-contents-left">
                <!-- 上 -->
                <div class="foreinger-list-item-contents-left-appointments">
                  <div
                    class="foreinger-list-item-contents-left-appointments-box"
                  >
                    <div class="foreinger-list-item-contents-left-general-w">
                    </div>
                    <div class="foreinger-list-item-contents-left-general-t">
                      就职机构及任职：
                    </div>
                  </div>
                  <div class="foreinger-list-item-contents-left-position">
                    {{item.institution}}
                  </div>
                </div>
                <!-- 上 结束-->
                <!-- 下 -->
                <div class="foreinger-list-item-contents-left-appointments">
                  <div
                    class="foreinger-list-item-contents-left-appointments-box"
                  >
                    <div class="foreinger-list-item-contents-left-general-w">
                    </div>
                    <div class="foreinger-list-item-contents-left-general-t">
                      擅长领域：
                    </div>
                  </div>
                  <div class="foreinger-list-item-contents-left-position-x">
                    {{item.areas_of_expertise}}
                  </div>
                </div>
                <!-- 下 结束-->
              </div>
              <!-- //5 -->
              <!-- //6 -->
              <div class="foreinger-list-item-contents-right">

                <div class="zan-box">
                  <div class="zan-box-img">
                    <img src="../../../assets/image/zan.png">
                  </div>
                  <div class="zan-box-name">{{item.pivot.like}}</div>
                </div>

                <div
                  class="foreinger-list-item-contents-right-box"
                  @click.stop="todetail(item)"
                >
                  <div class="foreinger-list-item-contents-right-box-img">
                    <img
                      src="../../../assets/image/foreignnationals/xiangqing.png"
                    >
                  </div>
                  <div class="foreinger-list-item-contents-right-box-text">
                    详情
                  </div>
                </div>

                <div
                  class="foreinger-list-item-contents-right-box"
                  @click.stop="expertdelete(item)"
                >
                  <div class="foreinger-list-item-contents-right-box-img">
                    <img
                      src="../../../assets/image/foreignnationals/shanchu.png"
                    >
                  </div>
                  <div class="foreinger-list-item-contents-right-box-text">
                    删除
                  </div>
                </div>

                <!-- 删除 -->
                <div
                  class="foreinger-list-item-contents-right-box"
                  @click.stop.prevent="recommendList(item)"
                >
                  <div class="foreinger-list-item-contents-right-box-img">
                    <img
                      style="width: 16px;height: 18px;"
                      src="../../../assets/image/foreignnationals/推荐进度_2@2x.png"
                    >
                  </div>
                  <div class="foreinger-list-item-contents-right-box-text">
                    推荐
                  </div>
                </div>
                <!-- 删除 -->
              </div>
              <!-- //6 -->
            </div>
            <!-- //4 -->
          </div>
          <!-- //2 -->
        </li>
      </ul>
    </div>
    <div class="page">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="currentchange"
        @prev-click="prevClick"
        @next-click="nextClick"
        :current-page.sync="currentPage"
        :page-count="aprenderObject.pages"
        hide-on-single-page
      >
      </el-pagination>
    </div>

    <!--推荐弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div class="dialog-recommend">
        <div class="dialog-recommend-name">推荐：</div>
        <div class="dialog-recommend-select">
          <el-select
            v-model="recommend_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="dialog-reason">
        <div class="dialog-reason-name">推荐理由：</div>
        <div class="dialog-reason-input">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入内容"
            v-model="argument"
            :autosize="{ minRows: 4, maxRows: 4}"
          >
          </el-input>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="referralSubmission"
        >确 定</el-button>
      </span>
    </el-dialog>

    <!--推荐弹窗 -->

  </div>
</template> 

<script>
export default {
  name: 'collectionDetails',
  data () {
    return {
      options: [{
        value: '1',
        label: '首推'
      }, {
        value: '2',
        label: '第二推荐'
      }, {
        value: '3',
        label: '第三推荐'
      }, {
        value: '4',
        label: '第四推荐'
      }, {
        value: '5',
        label: '第五推荐'
      }, {
        value: '6',
        label: '第六推荐'
      }],
      recommend_id: '',
      argument: '',
      dialogVisible: false,
      recommendText: '',
      input: '',
      userinfo: {},
      //外籍讲者
      total: 10,//总条目数
      pagesize: 8,//每页显示条目个数
      currentPage: 1,//当前页数    
      aprenderObject: { list: [] },
    };
  },
  activated () {
    document.querySelector('.el-main').scrollTop = 0
    this.getMe()
    this.getAprenderList()
  },
  methods: {
    //获取个人信息
    async getMe () {
      const { data: data } = await this.$http.post('me')
      this.userinfo = data.data
    },
    //获取外籍讲者列表 
    async getAprenderList () {
      const { data: data } = await this.$http.post("collection/detail", {
        name: this.input,
        collection_id: this.$route.query.id,
        page: this.currentPage,//第几页
        limit: this.pagesize,//每页条数
      })
      this.aprenderObject = data.data
      this.$Spin.hide();
    },
    //点击搜索 
    searchExpert () {
      this.currentPage = 1
      setTimeout(() => {
        this.getAprenderList()
      }, 500)
      this.$Spin.show();
    },
    //回车搜索
    change (value) {
      this.input = value
      this.currentPage = 1
      setTimeout(() => {
        this.getAprenderList()
      }, 500)
      this.$Spin.show();
    },
    // 外籍讲者详情  
    todetail (item) {
      this.$router.push({
        path: '/foreinerDetail', query: {
          id: item.id,
        }
      })
    },
    //删除
    expertdelete (item) {
      this.$confirm('您是否要删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const { data: data } = await this.$http.post("detail/delete", {
          collection_id: this.$route.query.id,
          speaker_id: item.id,
        })
        this.$message({
          message: data.message,
          type: 'success'
        });
        this.getAprenderList()
      }).catch(() => { })
    },
    //推荐合集 
    recommendList (item) {
      this.recommendText = item.id
      this.recommend_id = ''
      this.argument = ''
      this.dialogVisible = true
    },
    //推荐提交
    async referralSubmission () {
      this.dialogVisible = false
      const { data: data } = await this.$http.post('recommend/speaker', {
        collection_id: this.$route.query.id,
        speaker_id: this.recommendText,
        recommend_id: this.recommend_id,
        argument: this.argument,
      })
      this.$message({
        message: data.message,
        type: 'success'
      });
    },
    //点击每一页    
    currentchange (e) {
      this.currentPage = e
      document.querySelector('.el-main').scrollTop = 0
      setTimeout(() => {
        this.getAprenderList()
      }, 500)
      this.$Spin.show();
    },
    //上一页  
    prevClick (e) {
      this.currentPage = e
      document.querySelector('.el-main').scrollTop = 0
      setTimeout(() => {
        this.getAprenderList()
      }, 500)
      this.$Spin.show();
    },
    //下一页 
    nextClick (e) {
      this.currentPage = e
      document.querySelector('.el-main').scrollTop = 0
      setTimeout(() => {
        this.getAprenderList()
      }, 500)
      this.$Spin.show();
    },
  }
}

</script> 
<style lang="less" scoped>
.collection-details {
  padding: 0 10px;
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .title_box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 16px;
    margin-bottom: 23px;
    .title_flex {
      flex: 1;
      h4 {
        font-size: 28px;
        color: #212529;
      }
    }

    .inputBox {
      width: 430px;
      display: flex;
      margin-right: 0px;
      .el-input {
        flex: 1;
        margin-right: 16px;
      }
      .setDateTitle {
        margin-right: 14px;
        color: #8588ae;
        font-size: 18px;
      }
    }
  }
  /deep/ .el-card__body {
    padding: 10px;
  }
  .foreinger {
    .foreinger-list {
      min-height: 665px;
      .foreinger-list-item {
        margin-bottom: 20px;
        padding: 17px 0 22px 19px;
        border: 1px solid #f0f0f0;
        background-color: #fff;
        border-radius: 8px;
        display: flex;

        &:last-child {
          margin-bottom: 0px;
        }

        /deep/ .el-checkbox__label {
          width: 100%;
          margin-top: 20px;
          padding-left: 0px;
          display: flex;
        }
        .foreinger-list-item-heda {
          width: 61px;
          height: 61px;
          border-radius: 50%;
          overflow: hidden;
          margin-right: 19px;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .foreinger-list-item-box {
          flex: 1;
          .foreinger-list-item-title {
            display: flex;
            align-items: center;
            margin-bottom: 33px;
            .foreinger-list-item-name {
              color: #212529;
              font-size: 18px;
              font-weight: 600;
              max-width: 985px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .foreinger-list-item-country {
              margin-left: 160px;
              .foreinger-list-item-country1 {
                color: #212529;
                font-size: 18px;
                font-weight: 600;
              }
              .foreinger-list-item-country2 {
                font-size: 13px;
                color: #212529;
              }
            }
          }

          .foreinger-list-item-contents {
            display: flex;
            .foreinger-list-item-contents-left {
              width: 760px;
              .foreinger-list-item-contents-left-appointments {
                .foreinger-list-item-contents-left-appointments-box {
                  display: flex;
                  align-items: center;
                  margin-bottom: 12px;
                  .foreinger-list-item-contents-left-general-w {
                    width: 10px;
                    height: 4px;
                    background-color: #4687c8;
                    margin-right: 5px;
                  }
                  .foreinger-list-item-contents-left-general-t {
                    font-size: 13px;
                    color: #212529;
                  }
                }
                .foreinger-list-item-contents-left-position {
                  font-size: 13px;
                  color: #c7c7c7;
                  margin-bottom: 27px;
                }
                .foreinger-list-item-contents-left-position-x {
                  font-size: 13px;
                  color: #c7c7c7;
                }
              }
            }
            .foreinger-list-item-contents-right {
              flex: 1;
              display: flex;
              align-self: flex-end;
              justify-content: flex-end;
              .foreinger-list-item-contents-right-box {
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 40px;
                cursor: pointer;
                .foreinger-list-item-contents-right-box-text {
                  font-size: 14px;
                  color: #212529;
                  margin: 0 0 5px 5px;
                }
              }
            }
          }
          //
        }
      }
    }
  }
  .page {
    margin-top: 30px;
    text-align: right;
  }

  .dialog-recommend {
    display: flex;
    align-items: center;
    .dialog-recommend-name {
      margin-right: 10px;
      font-size: 15px;
      color: #2d2d2d;
      font-weight: 600;
      margin-left: 30px;
    }
    .dialog-recommend-select {
    }
  }

  .dialog-reason {
    margin-top: 30px;
    display: flex;
    align-items: center;
    .dialog-reason-name {
      margin-right: 10px;
      font-size: 15px;
      color: #2d2d2d;
      font-weight: 600;
    }
    .dialog-reason-input {
      width: 80%;
    }
  }

  .zan-box {
    display: flex;
    align-items: center;
    margin-right: 40px;
    margin-top: -4px;
    .zan-box-img {
      width: 18px;
      height: 18px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .zan-box-name {
      margin-left: 5px;
      margin-top: 2px;
    }
  }
}
</style> 